import { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { delay } from "lodash-es";
import { scrollTo } from "@/utils";

export const UserChangeTabs = (prefix: string, data: any, key?: string | null) => {
  const [current, setCurrent] = useState<string>("");
  const [container, setContainer] = useState<any>();
  const scrollListRef = useRef<any[]>([]);

  const dispatch = useDispatch();
  const scrollHeight = useSelector((state: any) => state.scrollHeight);

  const tabsChange = (item: any) => {
    const checkTabDom: any = document.getElementById(`${prefix}-module-${item.key}`);

    scrollTo(container, checkTabDom?.offsetTop - 100, 300, () => {
      dispatch({
        type: "setIsClickCauseScroll",
        payload: false,
      });
    });
  };

  const getItemDom = async (item: any) => {
    const checkTabDom: any = document.getElementById(`${prefix}-module-${item.key}`);
    return { key: item.key, top: checkTabDom.offsetTop };
  };
  const getDomData = () => {
    const promises = data.list.map(async (item: any) => {
      return await getItemDom(item);
    });

    Promise.all(promises)
      .then(async (data) => {
        scrollListRef.current = data;
      })
      .catch(() => {
        // ...
      });
  };

  useEffect(() => {
    key && tabsChange({ key });
  }, [key]);

  useEffect(() => {
    const keyItem = scrollListRef.current.find((item) => {
      return scrollHeight > item.top - 150 && scrollHeight < item.top - 50;
    });
    keyItem && setCurrent(keyItem.key);
  }, [scrollHeight]);

  useEffect(() => {
    const portalDom: any = document.getElementById("portal");
    setContainer(portalDom);
    delay(() => {
      getDomData();
    }, 500);
  }, [data]);

  useEffect(() => {
    getDomData();
  }, []);

  return { current, tabsChange };
};
